/**
 * Pestaña Evolución: la "serpiente" del marcador, un gráfico por set.
 *
 * El API no publica la progresión como endpoint: se deriva de los `point` del
 * log (recontando desde `wonBy`, no leyendo el marcador denormalizado, que
 * queda obsoleto apenas un `undo` revoca un punto anterior).
 */
import { ScoreLineChart } from '../../components/Charts';
import { Card, Empty } from '../../components/States';
import { useT } from '../../i18n/use-t';
import { groupScoreBySet, type ScorePoint } from '../../lib/projections';

export function EvolutionTab({
  score,
  homeName,
  awayName,
}: {
  score: readonly ScorePoint[];
  homeName: string;
  awayName: string;
}): JSX.Element {
  const series = groupScoreBySet(score);
  const t = useT();

  if (series.length === 0) {
    return (
      <Card>
        <Empty>{t('evolution.empty')}</Empty>
      </Card>
    );
  }

  return (
    <div>
      <div className="legend" style={{ marginBottom: 8 }}>
        <span>
          <span className="swatch home" />
          {homeName}
        </span>
        <span>
          <span className="swatch away" />
          {awayName}
        </span>
      </div>
      <div className="grid-2">
        {series.map((serie) => {
          const last = serie.points[serie.points.length - 1];
          return (
            <Card
              key={serie.set}
              title={t('common.set', { set: serie.set })}
              actions={
                <span className="chip muted">
                  {last?.home ?? 0} – {last?.away ?? 0}
                </span>
              }
            >
              <ScoreLineChart
                points={serie.points}
                homeName={homeName}
                awayName={awayName}
                set={serie.set}
              />
            </Card>
          );
        })}
      </div>
    </div>
  );
}
